import { watchScreenResize } from "../../utils";
import { EventBus, Events } from "../eventBus";
import { ElemID } from "./constants";
import { wayfinderGetSizingData } from "./wayfinder";

const MIN_ZOOM = 25;
const MAX_ZOOM = 400;

const zoomState = {
  editor: {
    autoFit: false,
    zoom: 100,
  },
  preview: {
    autoFit: false,
    zoom: 100,
  },
};

const pageContainerWrapper = document.getElementById(
  ElemID.EDITOR_PAGE_CONTAINER_WRAPPER,
);

const previewPageContainerWrapper = document.getElementById(
  ElemID.PREVIEW_PAGE_CONTAINER_WRAPPER,
);

export function getCurrentScale(screen) {
  return getCurrentZoom(screen) / 100;
}

function getCurrentZoom(screen) {
  const zoom = zoomState[screen].zoom;
  if (zoom === undefined) {
    throw new Error(`Invalid screen ${screen}`);
  }
  return zoom;
}

function applyZoom(newZoom, screen) {
  const current = getCurrentZoom(screen);
  if (current === undefined) {
    throw new Error(`applyZoom called with invalid screen '${screen}'`);
  }

  let cleanedValue = newZoom ? parseInt(newZoom, 10) : current;
  if (cleanedValue === current) {
    return;
  }
  cleanedValue = Math.max(MIN_ZOOM, cleanedValue);
  cleanedValue = Math.min(MAX_ZOOM, cleanedValue);

  zoomState[screen].zoom = cleanedValue;

  EventBus.emit(Events.SCALE_CHANGED, {
    autoFit: zoomState[screen].autoFit,
    zoom: cleanedValue,
    scale: cleanedValue / 100,
    screen: screen,
  });
}

EventBus.subscribe(Events.ZOOM_VALUE_UPDATED, function (payload) {
  if (payload.zoom === "fit") {
    zoomState[payload.screen].autoFit = true;
    revalAutoFit(payload.screen);
  } else {
    zoomState[payload.screen].autoFit = false;
    applyZoom(payload.zoom, payload.screen);
  }
});

export function getAutofitScale(screen) {
  const container =
    screen === "editor" ? pageContainerWrapper : previewPageContainerWrapper;

  const containerWidth = container.getBoundingClientRect().width;
  if (!container.offsetParent || !containerWidth) {
    console.debug(`revalAutoFit ignoring screen ${screen}.`);
    return;
  }

  const w = wayfinderGetSizingData();
  const targetWidth = w.maxPageWidth + w.spaceLeft + w.spaceRight; // widest page + left and right spacing
  return containerWidth / targetWidth;
}

function revalAutoFit(screen) {
  if (!zoomState[screen].autoFit) {
    return;
  }
  const targetScale = getAutofitScale(screen);
  if (targetScale) {
    applyZoom(targetScale * 100, screen);
  }
}

watchScreenResize(function () {
  revalAutoFit("editor");
  revalAutoFit("preview");
});

EventBus.subscribe(Events.HIDE_PREVIEW, function () {
  // trigger reval in case screen size changed in preview mode and editor now has wrong zoom value
  setTimeout(function () {
    revalAutoFit("editor");
  }, 500); // give some time for handle to hide the preview
});
